/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description payments constants
 */
import _ from 'lodash';
import { MONTH_DATE_YEAR_SLASH_FORMAT, SORT_COLUMN_LABELS } from '@veritable/common/constants';

const ALLOCATION_MODES: Record<PatientPayment.IPaymentAllocationMode, { label: string; value: PatientPayment.IPaymentAllocationMode }> = {
	all: {
		label: 'All',
		value: 'all',
	},
	unallocated: {
		label: 'Unallocated',
		value: 'unallocated',
	},
	allocated: {
		label: 'Allocated',
		value: 'allocated',
	},
};

/**
 * Payment Tabs
 */
const PAYMENT_TABS = {
	tabKey: 'tab',
	values: {
		unallocated: 'unallocated',
		allocated: 'allocated',
	},
};

const PAYMENT_METHODS = {
	cash: {
		label: 'Cash',
		value: 'CASH',
	},
	cdac: {
		label: 'Credit/Debit Account',
		value: 'CDAC',
	},
	ccca: {
		label: 'Credit Card',
		value: 'CCCA',
	},
	debc: {
		label: 'Debit Card',
		value: 'DEBC',
	},
	ccck: {
		label: 'Check',
		value: 'CHCK',
	},
	dbdo: {
		label: 'Direct Deposit',
		value: 'DBDO',
	},
	ach: {
		label: 'Automated Clearing House (ACH)',
		value: 'ACH',
	},
};

const PAYMENT_SORT_COLUMNS: Record<string, PatientPayment.IPaymentReconciliationSortColumn> = {
	collectedOn: 'collectedOn',
	amount: 'amount',
};

// default sort options for the sort table data
const PAYMENT_SORT_COLUMN_DEFAULT_OPTIONS = [
	{
		apikey: PAYMENT_SORT_COLUMNS.collectedOn,
		asc: true,
		label: `Collected On (${SORT_COLUMN_LABELS.oldToNew})`,
	},
	{
		apikey: PAYMENT_SORT_COLUMNS.collectedOn,
		asc: false,
		label: `Collected On (${SORT_COLUMN_LABELS.newToOld})`,
	},
	{
		apikey: PAYMENT_SORT_COLUMNS.amount,
		asc: true,
		label: `Collected Amount (${SORT_COLUMN_LABELS.lowToHigh})`,
	},
	{
		apikey: PAYMENT_SORT_COLUMNS.amount,
		asc: false,
		label: `Collected Amount (${SORT_COLUMN_LABELS.highToLow})`,
	},
];

// options for the sort table data
const PAYMENT_SORT_COLUMN_OPTIONS: SortItemType[] = _.map(PAYMENT_SORT_COLUMN_DEFAULT_OPTIONS, (option) => ({
	...option,
	key: option.label,
}));

const SEARCH_FIELDS_META = {
	collectedOn: {
		label: 'Collected On',
		placeholder: MONTH_DATE_YEAR_SLASH_FORMAT,
	},
	amount: {
		label: 'Collected Amount',
		placeholder: 'Eg.: 500',
	},
	guarantor: {
		label: 'Guarantor Name',
		placeholder: 'Eg.: Jane Doe',
	},
	referenceNumber: {
		label: 'Reference ID',
		placeholder: 'E.g.: TR9283GHYU',
	},
	paymentId: {
		label: 'Payment ID',
		placeholder: 'E.g.: PMT9283GHYU',
	},
};

export { ALLOCATION_MODES, PAYMENT_METHODS, PAYMENT_TABS, PAYMENT_SORT_COLUMNS, PAYMENT_SORT_COLUMN_OPTIONS, SEARCH_FIELDS_META };
